import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalDialogComponent } from '../modal-dialog/modal-dialog.component';
import { SafePipe } from '../../shared/pipes/safe.pipe';
import { AssistantHeaderComponent } from '../../features/assistant/assistant-header/assistant-header.component';
import { IconShieldComponent } from '../../shared/components/icon-components/icon-shield/icon-shield.component';

@Component({
  selector: 'app-unlock-lesson-modal',
  imports: [
    ModalDialogComponent,
    TranslateModule,
    SafePipe,
    AssistantHeaderComponent,
    IconShieldComponent,
  ],
  templateUrl: './unlock-lesson-modal.component.html'
})
export class UnlockLessonModalComponent {

  public dialogRef = inject(MatDialogRef<UnlockLessonModalComponent>);
  public data = inject(MAT_DIALOG_DATA);

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }

}
